import styled from 'styled-components';

import heroBg from '../../../assets/images/pattern-white.jpg';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Hero = styled.div`
  position: relative;
  width: 100%;
  color: #fff;
  background-color: #e74391;
`;

export const HeroImageContainer = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${heroBg});
  background-repeat: no-repeat;
  background-position-x: left;
  background-position-y: top;
  mix-blend-mode: multiply;

  @media (width < 4000px) {
    background-size: 2260px auto;
  }

  @media (width >= 4000px) {
    background-size: 100% auto;
  }
`;

export const HeroContent = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  min-height: 264px;

  @media (width < 1024px) {
    flex-direction: column;
    justify-content: center;
    padding: 54px 24px;
  }

  @media (width >= 1024px) {
    justify-content: center;
    gap: 34px;
  }
`;

export const HeroClubLogoContainer = styled.div`
  width: 210px;
  height: 45px;

  @media (width < 1024px) {
    margin-bottom: 30px;
  }

  svg {
    width: 100%;

    path {
      fill: #fff;
    }
  }
`;

export const StrategiesLogo = styled.img`
  width: 351px;
`;

export const DescSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  gap: 8px;
  max-width: 820px;
  text-align: center;

  @media (width < 1024px) {
    padding: 72px 24px;
  }

  @media (width >= 1024px) {
    padding: 54px 32px;
  }
`;

export const DescTitle = styled.h1`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
  text-transform: uppercase;
`;

export const Paragraph = styled.span`
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  &.--bg {
    background-color: #fff5f6;
  }

  @media (width < 1024px) {
    padding: 64px 0;
  }

  @media (width >= 1024px) {
    padding: 64px 32px;
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;

  @media (width >= 1024px) {
    max-width: 839px;
  }

  @media (width >= 1440px) {
    max-width: 1295px;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
  text-transform: uppercase;

  @media (width < 1024px) {
    padding: 0 32px;
  }
`;

export const Grid = styled.div`
  width: 100%;

  @media (width < 1024px) {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  @media (width >= 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 73px;
    row-gap: 48px;
  }

  @media (width >= 1440px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;
